import estadosCidades from '../../../../Assets/estados-cidades.json';

export const getCidadesByUF = (uf: string): string[] => {
    const estado = estadosCidades.estados.find(e => e.sigla === uf);
    return estado ? estado.cidades : [];
  };